module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_j_normal.95b302fa.png";